// Lifted out of ClientCaseEdit.js/ClientReviewEdit.js, which each had their own
// verbatim copy of this function.
export function slugify(str) {
  return (str || '').toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}
